import type { LmsAdapter, MappingFormData } from './types';

export const learndashAdapter: LmsAdapter = {
  lmsType: 'learndash',
  displayName: 'LearnDash',
  shortDescription: 'Koble LearnDash-kurs (WordPress) til en godkjent studieplan',
  colors: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    badge: 'bg-green-100 text-green-800',
    primary: 'bg-green-600 hover:bg-green-700'
  },
  courseIdField: {
    label: 'LearnDash kurs-ID (WordPress post-ID)',
    placeholder: 'F.eks. 789',
    helpText: 'WordPress post-ID for kurset (vises i WP-admin URL etter post=...)',
    inputType: 'number',
    validate: (v) => /^\d+$/.test(v.trim()) ? null : 'LearnDash kurs-ID må være et heltall',
    parse: (v) => parseInt(v.trim(), 10)
  },
  courseNameField: {
    label: 'Kursnavn i LearnDash',
    placeholder: 'Eksakt tittel som vist i LearnDash',
    required: true
  },
  endpoints: {
    listMappingsForMember: (mid) => `/api/learndash/mappings/member/${mid}`,
    listMappingsForIntegration: (iid) => `/api/learndash/mappings/${iid}`,
    createMappingForMember: (mid) => `/api/learndash/mappings/member/${mid}`,
    updateMapping: (id) => `/api/learndash/mappings/${id}`,
    deleteMapping: (id) => `/api/learndash/mappings/${id}`,
    listCoursesByMember: (mid) => `/api/learndash/courses/member/${mid}`
  },
  normalizeCourseList: (rawCourses) =>
    (rawCourses as Array<{ id: number; title: string; slug?: string; status?: string }>)
      .map(c => ({
        id: String(c.id),
        name: c.title,
        secondary: [c.slug, c.status && c.status !== 'publish' ? c.status : null].filter(Boolean).join(' · ')
      })),
  buildCreateBody: (data: MappingFormData) => ({
    // Backend forventer ld_course_id/_title (pre-eksisterende DB-skjema fra fase-2-tiden)
    ld_course_id: parseInt(data.lmsCourseId, 10),
    ld_course_title: data.lmsCourseName,
    study_plan_id: data.studyPlanId,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null,
    framework_rationale: data.frameworkRationale || undefined,
    has_rubric: Boolean(data.hasRubric)
  }),
  buildUpdateBody: (data: MappingFormData) => ({
    ld_course_title: data.lmsCourseName,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null,
    framework_rationale: data.frameworkRationale || undefined,
    has_rubric: Boolean(data.hasRubric)
  })
};
